// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ForgotPassword-__style___3z9RO","hr":"app-pages-ForgotPassword-__style___PaATL","title":"app-pages-ForgotPassword-__style___2VYK8","no-account":"app-pages-ForgotPassword-__style___195Mz","errorRequired":"app-pages-ForgotPassword-__style___2EWQg"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/ForgotPassword/style.css
// module id = 2096
// module chunks = 0